<!-- 1001：客户登记 -->
<template>
  <!-- :style="'min-height:'+screenHeight+'px;width:'+screenWidth+'px'" -->
<div     >  
    <div class="table">
        <div class="left"  > 
                <el-card class="newtable"  style="width:96%;margin-left:auto;margin-right:auto">
   
        <div slot="header" class="clearfix">
            <span>民间借贷计算器</span>

            <span  class="guide" @click="CheckDemo">查看案例模板</span>
            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
            <!-- <el-button type='text' style="float: right; padding: 3px 0;color:black" >填表日期： {{form.createDate}}</el-button> -->
        </div>
    
<!-- :model="form" -->
        <el-form ref="form"     label-width="150px" class="formtable">
            <el-col :span="24"   >
                <div class="tag_item"  > 基本情况 </div>
            </el-col>

              


 

            <el-form-item label="出借合同成立日期">
                <!-- <el-col :span="10"  >
                    <el-input :readonly="mode!='new'&&mode!='edit'&&mode!='rewrite'"  v-model="form.client_contact"  ></el-input>
                </el-col> -->
                
                <el-col :span="10"  >
                    <el-date-picker
                        @change="bindDateChange1"
                        :readonly="isReadOnly"
                        value-format="yyyy-MM-dd"
                        v-model="params.startDate"
                        type="date" 
                        placeholder="选择日期"
                        style="width:100%">
                    </el-date-picker>
                </el-col>


                <!-- margin-left:20px; -->
                <el-col class="line" :span="3"  > 借出本金 </el-col>
                <el-col :span="10"   >
                    <el-input :readonly="mode!='new'&&mode!='edit'&&mode!='rewrite'" type="number" v-model="params.amount"  ></el-input>
                
                </el-col>
            
            </el-form-item>


            <el-form-item label="债务到期日期">
                <!-- <el-col :span="10"  >
                    <el-input :readonly="mode!='new'&&mode!='edit'&&mode!='rewrite'"  v-model="form.client_contact"  ></el-input>
                </el-col> -->
                
                <el-col :span="10"  >
                    <el-date-picker
                        :readonly="isReadOnly"
                        value-format="yyyy-MM-dd"
                        v-model="params.expireDate"
                        type="date" 
                        placeholder="选择日期"
                        style="width:100%">
                    </el-date-picker>
                </el-col>


                <!-- margin-left:20px; -->
                <el-col class="line" :span="3"  > 计算截止日期 </el-col>
                 
                <el-col :span="10"  >
                    <el-date-picker
                        @change="bindChangeEndDate"
                        :readonly="isReadOnly"
                        value-format="yyyy-MM-dd"
                        v-model="params.endDate"
                        type="date" 
                        placeholder="选择日期"
                        style="width:100%">
                    </el-date-picker>
                </el-col>


            
            
            </el-form-item>


        

            <el-form-item label="起诉日期">
         
                
                <el-col :span="10"  >
                    <el-date-picker
                        :readonly="isReadOnly"
                        value-format="yyyy-MM-dd"
                        v-model="params.suitDate"
                        type="date" 
                        placeholder="不填即默认为截止日期"
                        style="width:100%">
                    </el-date-picker>
                </el-col>


     
            </el-form-item>

    

            <el-form-item label="最高利息模式">
            
                <el-col :span="10">
               
                    <el-switch   @change="radioChange_max"           active-value='yes' inactive-value='no'   v-model="params.maxmode"  ></el-switch>
            
                       
                    <span v-if="params.maxmode=='yes'" style="margin-left:10px">（是，即合同内和逾期利率都采取法律规定的上限）</span>
                    <span v-else style="margin-left:10px">否</span>
                
                </el-col>
               
         
         


            </el-form-item>
     

            <!-- <el-switch    style="margin-left:20px"     v-model="params.isInt" ></el-switch>  -->
            <div v-if="params.maxmode=='no'">  

                <div class="tag_item"  > 
                    <span style="width:200px">合同内利息约定</span>  
                    <el-switch    style="margin-left:20px"       v-model="params.isInt" ></el-switch> 
                    
                </div> 
         
     

                <!--   -->
                <el-form-item label="计息方式"   v-if="params.isInt" >
            
                    <el-col :span="10"  >
                        <el-select v-model="params.ratio_mode1" value-key="en" placeholder="请选择"     >
                        <!--    @change="bindRatioChange" -->
                            <el-option
                                v-for="item in ratio_arr"
                                :key="item.en"
                                :label="item.ch"
                                :value="item.en">
                            </el-option>
                        </el-select>
                    </el-col>



                    <!-- margin-left:20px; -->
                    <div v-if="params.ratio_mode1!='lpr1' && params.ratio_mode1!='lpr5'">
                        <el-col class="line" :span="3"  > 利率(小数) </el-col>
                        <el-col :span="10"   >
                            <el-input  type="number" v-model="params.ratio1"  placeholder="小数形式" ></el-input>
                        
                        </el-col>

                    </div>
                
                
                </el-form-item>




    

                <div class="tag_item"  > 
                    <span style="width:200px">逾期利息约定</span>  
                    <el-switch    style="margin-left:20px"       v-model="params.isExpireInt" ></el-switch> 
                    
                </div> 

             

                <el-form-item label="计息方式" v-if="params.isExpireInt">
            
                    
        

                    <el-col :span="10"  >
                        <el-select v-model="params.ratio_mode2" value-key="en" placeholder="请选择"     >
                        <!--    @change="bindRatioChange" -->
                            <el-option
                                v-for="item in ratio_arr"
                                :key="item.en"
                                :label="item.ch"
                                :value="item.en">
                            </el-option>
                        </el-select>
                    </el-col> 



                    <!-- margin-left:20px; -->
                    <div v-if="params.ratio_mode2!='lpr1' && params.ratio_mode2!='lpr5'">
                        <el-col class="line" :span="3"  > 利率(小数) </el-col>
                        <el-col :span="10"   >
                            <el-input  type="number" v-model="params.ratio2"  placeholder="小数形式" ></el-input>
                        
                        </el-col>

                    </div>

                
                
                
                </el-form-item>

                <div style='width:100%;margin:20px 0; '  v-if="params.isPart1=='yes' && params.isExpireInt"  > 
                    <!-- -->
                    <div class='tips'  > *截止日期早于债务到期日期，逾期利息约定不起作用 </div>
                </div>

            </div>

            <div class="tag_item"  > 
                <span style="width:200px">其他参数设置</span>   
                <!-- <el-switch    style="margin-left:20px"       v-model="params.isExpireInt" ></el-switch>  -->
                
            </div> 

            <!-- <div class='optionitem' :style="isPhone?'width:100%':'' " >    -->
            <el-form-item label="自然年天数基准：" >
                <el-col :span="10"  >
                   <el-radio-group v-model="params.method_year"  >
                        <el-radio label="360">360</el-radio>
                        <el-radio label="365">365</el-radio>
                    </el-radio-group>
                </el-col>

             
            </el-form-item>
            <!-- </div> -->



            <!-- <el-col :span="24"   >
                <div class="tag_item"  > 期间还款 <span style="font-size:14px">（会员功能，不计算复利）</span> </div>
            </el-col> -->


            <el-col :span="24"   >
                <div class="plus_box">
                    <div class='tag_item'>  
                        <!-- refund_box -->
                        <div style="width:80%">  
                            <el-badge value="hot"   >
                                <!-- <el-button size="small">回复</el-button> -->
                                <span title='解决中间夹杂付款或还款的场景，计算更加简单' >还款记录(会员功能 ）：</span>
                            </el-badge>

                        </div>
                        

                        <!-- <span style="width:85%">期间付款或还款记录(会员功能）：</span> -->
                        <span   >
                            
                            <router-link  to="/community/enk91631296197" target='_blank'  class="guide">   
                                使用说明
                            </router-link>    
                        </span> 
                        <i  class="el-icon-circle-plus" style="font-size:24px;cursor:pointer;margin-left:35px" @click="AddLine"></i>  
                            
                    </div>

                    <div class='newline'   v-for="(item,index) of params.cond" v-bind:key="index">   
                        <div class="newline item_name" style="text-align:center">  还款日期: </div>
                        <!-- param.cond[index] -->
                        <el-date-picker
                            v-model="item.date"
                            align="right"
                            type="date"
                            placeholder="选择日期"
                            format='yyyy-MM-dd'
                            value-format='yyyy-MM-dd'
                            >
                        </el-date-picker>

                        <span  class="newline item_name"    style="text-align:center">还款金额：</span>
            

                        <el-input class="newline item_detail" type='number' min=0 v-model="item.amount" ></el-input> 

                        <i   class="el-icon-remove"  style="font-size:24px;cursor:pointer;margin-top:8px;margin-left:10px"  @click="RemoveLine(index)"></i>

                
        
                    </div>  


                </div>


            </el-col>



            <div  style="margin-top:240px;width:100%;display:flex;flex-direction:row">
                <!-- <button @click="alert('ok')" type="button">Click Me!</button>
                <button type="button">Cancle!</button> -->

     
                <el-row style="margin:auto">

                    <el-button @click="newcal" type="primary"  style="width:120px" >计算</el-button>
                    <el-button type="warning" style="margin-left: 50px;width:120px" >重置</el-button>
            
                </el-row>
            </div>





            <div class="tag_item2"  style="margin-top:50px;padding:0 10px; height:60px;justify-content:space-between"> 

                <span> 详情 </span>
                <el-button type="warning" plain @click="bind_download"  >下载详情文档(VIP专享)</el-button>
            </div>

            <div class="result_box">
                <p class='item_result'   :decode="true" style=' font-weight:bold;color:red'>&nbsp;&nbsp;&nbsp;&nbsp;借期内：  {{params.startDate}}到{{params.isPart1 && params.isPart1=='yes'?   params.endDate : params.expireDate}} </p>

                <div class='item_result2'     >
                    <!-- <text  selectable decode="true">&nbsp;&nbsp;&nbsp;&nbsp;借期内：  {{params.startDate}}到{{params.expireDate}}  </text> -->
                    <p  v-if="result.part1"  >&nbsp;&nbsp;&nbsp;&nbsp;本息合计：【 {{result.part1[result.part1.length-1].sum}}  】  </p>
            
                </div>

                <div class="table2">
                    <div class='table-item'>
                        <div class='table-detail'>
                        计算本金
                        </div>
                        <div class='table-detail'>
                        还款总额
                        </div>
                        <div class='table-detail'>
                        本金剩余
                        </div>
                        <div class='table-detail'>
                        本期利息
                        </div>

                        <div class='table-detail'>
                        利息结余
                        </div>

                        <div class='table-detail'>
                        本息结算
                        </div>

                    </div>


                    <div class='table-item'>
                        <div class='table-detail'> 
                        
                            {{result.params.amount}}
                        </div>
                        <div class='table-detail'>
                            {{ result.payback_1 }}
                        </div>
                        <div class='table-detail'>
                            {{  result.left_capital_p1  }}
                        </div>
                        <div class='table-detail'>
                            {{ result.total_int_1     }}
                        </div>

                        <div class='table-detail'>
                            <span v-if="result.part1">
                               {{ result.part1[result.part1.length-1].int_sum }}
                            </span>
                            
                             
                        </div>

                        <div class='table-detail'>
                            <span v-if="result.part1">
                                {{ result.part1[result.part1.length-1].sum }}
                            </span>
                        
                        
                        </div>


                      

                    </div>




                </div>

                <p class='item_result'   >&nbsp;&nbsp;&nbsp;&nbsp; 计算详情：   </p>


                <div class="table2">
                    <div class='table-item'>
                        <div class='table-detail'  style='width:150px'>
                            日期段
                        </div>
                        <div class='table-detail' style='width:280px;text-align:center'>
                            利息算法
                        </div>

                        <div class='table-detail'  >
                            还款金额
                        </div>

                        <div class='table-detail'  >
                            结算
                        </div>
                    
                    </div>


                    <div class='table-item'  v-for="(item,index) of result.part1" v-bind:key="index"      >   
                        <div  v-if=" (item.param && item.param.type && item.param.type=='LPR' ) || item.result.total_lpr  "  class='table-item' >
                            <div class='table-detail' style='width:150px'> 
                        
                                {{item.startDate? item.startDate: item.result.startDate }} 至 
                                <span><br> {{item.endDate?item.endDate:item.result.endDate}}</span>
                            
                            </div>
                        
                            <!-- <div class='table-detail'   style='width:280px; max-height: 240px;overflow-y: scroll;   color: rgb(19, 109, 145); text-decoration: underline;'  >
                          
                                {{ item.result.lpr_mode=='lpr1'? item.result.algorithm_1:item.result.algorithm_5 }} {{item.int? '='+item.int :'' }}
                            </div> -->

                            <div  v-if="$store.state.accountInfo.vip==1  " class='table-detail'   style='width:280px; max-height: 240px;overflow-y: scroll;   color: rgb(19, 109, 145); text-decoration: underline;'  >
                              <!-- {{ item.result.lpr_mode=='lpr1'? item.result.algorithm_1:item.result.algorithm_5 }} {{item.int? '='+item.int :'' }} -->
                        
                                {{  item.result.algorithm_merge }} {{item.int? '='+item.int :'' }}
                        
                            </div>
                        
                            <div v-else class='table-detail'   style='width:280px; max-height: 240px;overflow-y: scroll;   color: rgb(19, 109, 145); text-decoration: underline;'  >
                                <!-- style='width:280rpx; max-height: 240rpx;overflow-y: scroll;   color: rgb(19, 109, 145); text-decoration: underline;' -->
                    

                                <span     @click="beVip" style="text-align:center;  text-decoration: underline; color: rgb(19, 109, 145); cursor: pointer;padding-left:50px"> 会员可见，成为会员，还可下载详情文档</span>
                            
                            </div>

                           

                            <div class='table-detail'  >
                                {{item.amount? item.amount : 0 }}
                            </div>

                            <div class='table-detail'  >
                                {{item.sum}}
                            </div>

                        </div>

                        <div v-else class='table-item' >
                            <div class='table-detail' style='width:150px' > 
                         
                
                            {{item.startDate? item.startDate: item.result.startDate }} 至 {{item.endDate?item.endDate:item.result.endDate}}

                            </div>
                        
                            <div class='table-detail'   style='width:280px;max-height: 240px;overflow-y: scroll; ' >
                
              
                            {{ item.result.algorithm }} {{item.int? '='+item.int :'' }}
                
                            </div>
 

                            <div class='table-detail'  >
                            {{item.amount? item.amount : 0 }}
                            </div>

                            <div class='table-detail'  >
                            {{item.sum}}
                            </div>

                        
                        </div>


                    </div>




                </div>



            </div>

     
           <div v-if="result.part2 && result.part2.length>0">
                <p class='item_result'  :decode="true" style='font-weight:bold;color:red'>&nbsp;&nbsp;&nbsp;&nbsp;逾期期间：  {{params.expireDate}}到{{params.endDate}} </p>
                <div class='item_result2'  :decode="true"  >
                    <text   decode="true">&nbsp;&nbsp;&nbsp;&nbsp; 本息合计：【 {{result.part2[result.part2.length-1].sum}}  】  </text>
            
                </div>



                <div class="table2">
                    <div class='table-item'>
                        <div class='table-detail'>
                        计算本金
                        </div>
                        <div class='table-detail'>
                        还款总额
                        </div>
                        <div class='table-detail'>
                        本金剩余
                        </div>
                        <div class='table-detail'>
                        本期利息
                        </div>

                        <div class='table-detail'>
                        利息结余
                        </div>

                        <div class='table-detail'>
                        本息结算
                        </div>

                    </div>


                    <div class='table-item'>
                        <div class='table-detail'> 
                        
                            {{result.left_capital_p1}}
                        </div>
                        <div class='table-detail'>
                            {{result.payback_2}}
                        </div>
                        <div class='table-detail'>
                            {{result.left_capital_p2}}
                        </div>
                        <div class='table-detail'>
                            {{result.total_int_2}}
                        </div>

                        <div class='table-detail'>
                            {{result.int_sum_1_2}}
                            
                                
                        </div>

                        <div class='table-detail'>
                            {{result.sum_1_2}}
                        
                        
                        </div>


                        

                    </div>




                </div>


           </div>
          


            <p v-if="result.part2" class='item_result'  :decode="true">&nbsp;&nbsp;&nbsp;&nbsp; 计算详情：   </p>



            <div class="table2">
                <div class='table-item'>
                    <div class='table-detail'  style='width:150px'>
                        日期段
                    </div>
                    <div class='table-detail' style='width:280px;text-align:center'>
                        利息算法
                    </div>

                    <div class='table-detail'  >
                        还款金额
                    </div>

                    <div class='table-detail'  >
                        本段本息
                    </div>

                    <div class='table-detail'  >
                        两段合计
                    </div>
                
                </div>


                <div class='table-item'  v-for="(item,index) of result.part2" v-bind:key="index"      >   
                    <div  v-if=" (item.param && item.param.type && item.param.type=='LPR' ) || item.result.total_lpr  "  class='table-item' >
                        <div class='table-detail' style='width:150px'> 
                      
                            {{item.startDate? item.startDate: item.result.startDate }} 至 {{item.endDate?item.endDate:item.result.endDate}}
                        
                        </div>

                         <!-- v-if="$store.state.accountInfo.vip==1 || isDemo==1 "  -->

                        <div  v-if="$store.state.accountInfo.vip==1  " class='table-detail'   style='width:280px; max-height: 240px;overflow-y: scroll;   color: rgb(19, 109, 145); text-decoration: underline;'  >
                            <!-- {{ item.result.lpr_mode=='lpr1'? item.result.algorithm_1:item.result.algorithm_5 }} {{item.int? '='+item.int :'' }} -->
                        
                            {{  item.result.algorithm_merge }}{{item.int? '='+item.int :'' }} 
                        </div>
                    
                        <div v-else class='table-detail'   style='width:280px; max-height: 240px;overflow-y: scroll;   color: rgb(19, 109, 145); text-decoration: underline;'  >
                            <!-- style='width:280rpx; max-height: 240rpx;overflow-y: scroll;   color: rgb(19, 109, 145); text-decoration: underline;' -->
                   

                            <span     @click="beVip" style="text-align:center;  text-decoration: underline; color: rgb(19, 109, 145); cursor: pointer;padding-left:50px"> 会员可见，成为会员，还可下载详情文档</span>
                        
                        </div>

                        

                        <div class='table-detail'  >
                            {{item.amount? item.amount : 0 }}
                        </div>

                        <div class='table-detail'  >
                            {{item.sum}}
                        </div>

                        <div class='table-detail' v-if="index==result.part2.length-1"  >
                            {{result.sum_1_2}}
                        </div>

                    </div>

                    <div v-else class='table-item' >
                        <div class='table-detail' style='width:150px' > 
                        
            
                        {{item.startDate? item.startDate: item.result.startDate }} 至 {{item.endDate?item.endDate:item.result.endDate}}

                        </div>
                    
                        <div class='table-detail'   style='width:280px;max-height: 240px;overflow-y: scroll; ' >
            
            
                        {{ item.result.algorithm }} {{item.int? '='+item.int :'' }}
            
                        </div>


                        <div class='table-detail'  >
                        {{item.amount? item.amount : 0 }}
                        </div>

                        <div class='table-detail'  >
                          {{item.sum}}
                        </div>

                        <div class='table-detail'  v-if="index==result.part2.length-1">
                          {{result.sum_1_2}}
                        </div>

                    
                    </div>


                </div>




            </div>





        

   


        
        </el-form>


    

    </el-card>

        </div>

        <div   class="block-right"    > 
            <div class="result">
                <h4>计算结果：</h4>
                <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;初始本金： {{params.amount}}  </p>
                <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;最终本息欠款合计： {{result.sum_1_2}}</p>

            </div>

            <div class="tag_item2"  > 借贷关系模型 </div>

            <p class='item_result' style=' word-spacing:0.13em;  white-space:pre-wrap;   width:92%;margin-left:auto;margin-right:auto' :space="true"  :decode="true"> 
                {{result.params.model}}  
            </p>

            <div class="tag_item2"  > 信息反馈 </div>

            <div class='tips_box'  v-if="result.params.tips && result.params.tips.length>0">
        
                <p   v-for="(item,index) of result.params.tips" v-bind:key="index"   :class="item.type=='error'? 'tiptxt_error':'tiptxt' "   :decode="true">&nbsp;&nbsp;&nbsp;&nbsp;{{index+1}}. {{item.txt}} </p>

           

            </div>


            

         



        </div>

    </div>

 

</div>

 
 

</template>

<script>

    function sendHeight() {
        const height = document.body.scrollHeight;

        // 向父页面发送消息，包含 iframe 的高度
        window.parent.postMessage({ type: 'resize', height: height }, 'https://www.lawtip.cn');  
    }
   function sendParentMsg(msg , msgType ) {
    
        // http://localhost:3000/
        // 向父页面发送消息，包含 iframe 的高度
        window.parent.postMessage({ type: 'notification', msg: msg , msgType : msgType }, 'https://www.lawtip.cn');  //https://www.lawtip.cn
    }



    function getNum() {
        var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A',
            'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
            'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y',
            'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
            'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w',
            'x', 'y', 'z'];
        var nums = "";
        for (var i = 0; i < 8; i++) {
            var id = parseInt(Math.random() * 61);
            nums += chars[id];
        }
        return nums;
    }

  



	export default {
        name: 'int5',
        metaInfo: {
            title: '民间借贷计算器', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: '民间借贷,计算器'
            }],
      
        },
        props: {
            // form:Object,
            // mode:String,
		}, 
        data() {
			return {
                isReadOnly:false,
                errMsg:'',


                isInt:false,  //主要为了解决switch值不变的bug，需要通过change事件把值赋予params.isInt
                isExpireInt:false,    //主要为了解决switch值不变的bug，需要通过change事件把值赋予params.isInt
                result: { totalInt_1: 0, totalInt_5:0 ,params:{}},
                method_year:'360',


                params:{              //params 新的参数集成
                    // amounts:[
                    //   {amount:0,date: new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getDate() }
                    // ],
                    int_limit: '', //只有20年8月20日后的部分需要考虑这一个
                    amount:'',
                    startDate: '', //new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate(),
                    suitDate:'',
                    param1:'no',
                    cond:[],
                    endDate: '', // new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate() ,
                    expireDate: '', //  new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate() ,
                    contract_int:0,
                    expire_int:0,

                    //合同期内 start
                    ratio_mode1:'day',
                    ratio1:'',
                    lpr_mode1:'lpr1',
                    //合同期内 end

                    //逾期 start
                    ratio_mode2:'day',
                    ratio2:'',
                    lpr_mode2:'lpr1',
                    //逾期 end

                    isInt:false ,
                    isExpireInt:false, 
 
               

                    maxmode:'no',

                    method_year:'360',
                    days_mode:'mode_d1',
                    

                    part1:{}, //合同期内
                    part2:{}, //合同期外

                    explain:[], //一些注释


                },  
                gap_tmsp: 1597852800 ,// 1597852800,  //2020年8月20日的时间戳  19年8月20日 1566230400
                time_19820:1566230400,
                
                // ratio_arr:['日息','月息','年息','一年期lpr利率','五年期lpr利率'],
                ratio_dic:{"day":'日息','mon':'月息','year':'年息','lpr1':'1年期lpr利率', 'lpr5' :'5年期lpr利率' },

                ratio_arr:[
                    {en:'day', ch:'日息' },
                    {en:'mon', ch:'月息' },
                    {en:'year', ch:'年息' },
                    {en:'lpr1', ch:'1年期lpr利率' },
                    {en:'lpr5', ch:'5年期lpr利率' },

                ],

                block:false,
                block_msg:'',
       
                int_drawer:false,
                conflict_list:[],
                client_conflict_check:'all',



                screenWidth:window.innerWidth,
                screenHeight:window.innerHeight,

                // get_sheet_sig:1,
                // cform:{},
                submit_sig:0,

                login:{name:'',code:''},
                client_drawer:false,
                case_drawer:false,
                keyword:'',
                myclient:[],
                mycase:[],
                client_index:0,
                
                flow_id:'',
                mode:'new',
                // id:'',
                sheet:{},
                process_staff:[],
                decision:{"status":0,"msg":""},
                step:'',
                
      
            

  

        

           
         
                examine_staff:[],
                procedure:[
                    {timestamp:'0', staff:[ '王小虎','张三丰','流川枫'],content:''},
                    {timestamp:'1', staff:[],content:''},
                    {timestamp:'2', staff:[],content:''},
                ],

			}
        },
        mounted() {
            //    console.log('template_id  1001 start mode:',this.mode)
 
            window.addEventListener('load', sendHeight);
		    window.addEventListener('resize', sendHeight);
           

  

 

            // this.screenWidth = document.body.clientWidth;
            // this.screenHeight = document.body.clientHeight;
            // window.onresize = () => {
            //     return (() => {
            //         window.console.log('document.body.clientWidth:',document.body.clientWidth)
            //         window.console.log('document.body.clientHeight:',document.body.clientHeight)
                   
            //         this.screenWidth = document.body.clientWidth;
            //         this.screenHeight = document.body.clientHeight;
            //         if (document.body.clientWidth<=1100){
            //             this.rightOnShow=false
            //         }else{
            //              this.rightOnShow=true
            //         }

            //     })();
            // };
        },
        methods: {

            // timestampToTime(timestamp) {
            //     var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            //     var Y = date.getFullYear() + '-';
            //     var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            //     var D = date.getDate() + '';
            //     // var h = date.getHours() + ':';   //
            //     // var m = date.getMinutes() + ':';//
            //     // var s = date.getSeconds();//
            //     if (M.length==1){
            //         M='0' +M
            //     }
            //     if (D.length==1){
            //         D='0' +D
            //     }
            //     return Y + M + D ;  //+ h + m + s
            // },
            AddLine(){
                var that=this 
                if(this.$store.state.accountInfo.vip!=1){
                    that.$message({
                        type: 'info',
                        message:'该功能为会员功能',
                        showClose: true,
                        duration:3000,
                    });
                    sendParentMsg( '该功能为会员功能' , 'info')
                    return
                }
                if(this.params.cond.length<100){

                    let obj=that.params.cond
                    let date= new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate()
                    let t= { amount:0 ,date:  date , }  // kind:'back'   s1: 'plus'  ,
                    this.params.cond.push(t)
                    // obj.push(t)
                    // that.setData({
                    //     'param.cond':obj
                    // })
                }else{
                    that.$message({
                        type: 'info',
                        message:'超过支持上限',
                        showClose: true,
                        duration:3000,
                    });
                    sendParentMsg( '超过支持上限' , 'info')
                  
                }
            },

            RemoveLine(index){
            
                // let index=e.currentTarget.dataset.ind
                if(this.params.cond.length>=1){
                 
                    let obj=this.params.cond
                    
                    obj.splice(index,1)
                    this.params.cond=obj
                    // this.setData({
                    //     'param.cond':obj
                    // })
                }

            },

            
            radioChange_max(value){
                // console.log(value)
                this.params.isInt=false 
                this.params.isExpireInt=false 
                // this.setData({
                // 'params.maxmode':e.detail.value,
                // 'params.isInt':false,
         
                // 'params.isExpireInt':false,
                // })


            },




            
            // switch1Change(value){
            //     console.log('value:',value)
         
            //     // this.params.isInt=value
            //     // this.$forceUpdate();
           
            // },
            // switch2Change(value){
            //     this.params.isExpireInt=value 
             
            // },

            bindRatioChange(value){
                // ratio_arr:['日息','月息','年息','一年期lpr利率','五年期lpr利率'],
                // ratio_dic:{"day":'日息','mon':'月息','year':'年息','lpr1':'1年期lpr利率', 'lpr5' :'5年期lpr利率' },


            },

            newcal(){
                var that = this;
                if(!this.params.startDate || !this.params.amount){
        
                    that.$message({
                        type: 'error',
                        message:'借款金额和日期不能为空',
                        showClose: true,
                        duration:3000,
                    });
                    sendParentMsg( '借款金额和日期不能为空' , 'info')
                    return
                }

                if(!this.params.expireDate || !this.params.endDate){
            
                    that.$message({
                        type: 'error',
                        message:'债务到期或截止日期不能为空',
                        showClose: true,
                        duration:3000,
                    });
                    sendParentMsg( '债务到期或截止日期不能为空' , 'info')
                    return
                }

                if(this.params.isInt && this.params.ratio_mode1 && !this.params.ratio1 && this.params.ratio_mode1!='lpr1' &&  this.params.ratio_mode1!='lpr5'   ){
            
                    that.$message({
                        type: 'error',
                        message:'未设置借期利率',
                        showClose: true,
                        duration:3000,
                    });
                    sendParentMsg( '未设置借期利率' , 'error')
                    return
                }

                if(this.params.isExpireInt && this.params.ratio_mode2 && !this.params.ratio2 && this.params.ratio_mode2!='lpr1' &&  this.params.ratio_mode2!='lpr5'  ){
    
                    that.$message({
                        type: 'error',
                        message:'未设置逾期利率',
                        showClose: true,
                        duration:3000,
                    });
                    sendParentMsg( '未设置逾期利率' , 'error')
                    return
                }


                var params= JSON.parse(JSON.stringify(this.params));
                var cond =  params.cond
                // console.log('cond  0:',cond)

                params.endDate_tmsp=Date.parse(params.endDate)/1000 
                params.expireDate_tmsp=Date.parse(params.expireDate)/1000 
                params.startDate_tmsp=Date.parse(that.params.startDate)/1000 

                if( params.startDate_tmsp>=params.expireDate_tmsp  ||  params.startDate_tmsp>=params.endDate_tmsp  ){
          

                    that.$message({
                        type: 'error',
                        message:'开始日期要小于到期或截止日期',
                        showClose: true,
                        duration:3000,
                    });
                    sendParentMsg( '开始日期要小于到期或截止日期' , 'error')
                    return
                }


                let arr=[
                    { amount:params.amount, date: params.startDate ,timestamp: params.startDate_tmsp,attr:'loan'  },
                    {  amount:0 , date: params.expireDate ,timestamp: params.expireDate_tmsp ,attr:'expire'  },
                    {  amount:0 , date: params.endDate ,timestamp: params.endDate_tmsp ,attr:'end'   }
                ]



                for(let p of cond){
   

                    // p.date=p.date.replace(/\//g, "-")
                    p.timestamp=Date.parse(p.date)/1000
                    p.attr='pay'
                    // console.log('p.date:',p.date)
                    // console.log('p.timestamp:',p.timestamp)

                    if( (!p.amount || p.amount==0) && p.timestamp!=Date.parse(this.params.endDate)/1000  ){
                        that.$message({
                            type: 'error',
                            message:'还款金额不能为0',
                            showClose: true,
                            duration:3000,
                        });
                        sendParentMsg( '还款金额不能为0' , 'error')
                        return
                    }

                    if( params.startDate_tmsp>p.timestamp){
              
                        that.$message({
                            type: 'error',
                            message:'开始日期要小于还款日期',
                            showClose: true,
                            duration:3000,
                        });
                        sendParentMsg( '开始日期要小于还款日期' , 'error')
                        return
                    }

                    if(params.endDate_tmsp<p.timestamp){
        
                        that.$message({
                            type: 'error',
                            message:'还款日期要小于截止日期',
                            showClose: true,
                            duration:3000,
                        });
                        sendParentMsg( '还款日期要小于截止日期' , 'error')
                        return
                    }

                }

                arr=arr.concat(cond)
                arr.sort((x,y)=>{
                    return x.timestamp-y.timestamp

                })

                for(let k of arr){
                    if(k.timestamp>=1566230400){  //19/8/20
                        k.support=['lpr1','lpr5']
                    }else{
                        k.support=[]
                    }

                    if(k.timestamp>=1597852800){  //20/8/20
                        k.maxInt=0.154
                    }else{
                        k.maxInt=0.24
                    }

                    if(k.timestamp<= params['expireDate_tmsp']  ){  //20/8/20
                        k.range='contract'
                    }else{
                        k.range='breach'
                    }
                    



                }
                cond.sort((x,y)=>{
                    return x.timestamp-y.timestamp

                })

                if(params.isInt && params.endDate_tmsp <1566230400 && (  params.ratio_mode1=='lpr1' ||  params.ratio_mode1=='lpr5' )  ){ //19年8月20日时间戳：1566230400；20年8月20日：gap_tmsp
                    // this.setData({
                    //     error:'19年8月20日以前借期内不支持采用LPR利率'
                    // })

                    that.$message({
                        type: 'error',
                        message:'19年8月20日以前借期内不支持采用LPR利率',
                        showClose: true,
                        duration:3000,
                    });
                    sendParentMsg( '19年8月20日以前借期内不支持采用LPR利率' , 'error')
                    return
                
                
                }


                if( params.endDate_tmsp<=  params.expireDate_tmsp ){
                    params.isPart1='yes'  //没有逾期利息需要计算
                }else{
                    params.isPart1='no'
                }



                if(params.isInt && params.expireDate_tmsp<1566230400 && (params['ratio_mode1']=='lpr1' || params['ratio_mode1']=='lpr5')  ){
    
                    that.$message({
                        type: 'error',
                        message:'到期日在20年8月20日前不支持合同内利率设置为LPR利率',
                        showClose: true,
                        duration:3000,
                    });
                    sendParentMsg( '到期日在20年8月20日前不支持合同内利率设置为LPR利率' , 'error')
                    return  //其实应该是19年8月20日前

                }

                    // params.isExpireInt && 
                if(params.isExpireInt && params.endDate_tmsp<1566230400 && (params['ratio_mode2']=='lpr1' || params['ratio_mode2']=='lpr5')  ){
                    that.$message({
                        type: 'error',
                        message:'截止日在19年8月20日前不支持逾期利率设置为LPR利率',
                        showClose: true,
                        duration:3000,
                    });
                    sendParentMsg( '截止日在19年8月20日前不支持逾期利率设置为LPR利率' , 'error')
                    return  //其实应该是19年8月20日前

                }


                let con_len=cond.length 
                let p1_cond=cond 
                let p2_cond=[] 
                for (let i=0;i<con_len;i++){
                    // console.log(cond[i].timestamp)
                    // console.log( params.expireDate_tmsp)
                    if(cond[i].timestamp> params.expireDate_tmsp ){ 
                        // console.log('i:',i)
                        p1_cond=cond.slice(0,i)
                        // console.log('cond:',cond)
                
                        p2_cond=cond.slice(i)
                        break
                    }
                }


                params.part1.cond=p1_cond
                params.part2.cond=p2_cond

                params.part1.amount=params.amount 

                this.params=params

                this.getResult()

















 


            





            },




            getResult(){ //mark
                var that = this;
                let data={
                    params:this.params,
                    whattodo:'int5cal'
                }

                this.axios.post(this.$root.rootUrl+'lpr',data
                ).then(function (res) {
                    // window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        // console.log('result:',result)
                        if(result.status=='badgate'){
                            that.$message({
                                type: 'info',
                                message:'请先登录',
                                showClose: true,
                                duration:3000,
                            });
                            sendParentMsg( '请先登录' , 'info')

                        }else if(result.status=='ok'){
                            that.$message({
                                type: 'success',
                                message:'计算成功',
                                showClose: true,
                                duration:3000,
                            });
                            sendParentMsg( '计算成功' , 'success')

                            let data=result.data 
                            let p1=[],p2=[];
                            for (let q of data.part1){
                                if (Array.isArray(q.result)){
                                    p1=p1.concat(q.result)
                                }else{
                                    p1.push(q)
                                }
                            }
                            if(data.part2){
                                for (let q of data.part2){
                                    if (Array.isArray(q.result)){
                                    p2=p2.concat(q.result)
                                    }else{
                                    p2.push(q)
                                    }
                                }
                            }
                            data.part1=p1
                            data.part2=p2 

                            let t
                            data.part1[data.part1.length-1].sum=filters.toFix(parseFloat(  data.part1[data.part1.length-1].sum ))
                            data.left_capital_p1 =   filters.toFix(parseFloat( data.left_capital_p1 ))
                            data.total_int_1  = filters.toFix(parseFloat(  data.total_int_1 ))
                            data.total_int_2  = filters.toFix(parseFloat(  data.total_int_2 ))
                            data.int_sum_1_2= filters.toFix(parseFloat( data.int_sum_1_2 ))
                            data.sum_1_2= filters.toFix(parseFloat(data.sum_1_2  ))

                            if(data.part2 && data.part2.length>0){
                                data.part2[data.part2.length-1].sum_1_2=  filters.toFix(parseFloat( data.part2[data.part2.length-1].sum_1_2 ))

                            } 



                            let a1='',a5='',len,lpr
                            for(let p of data.part1){

                                p.int= filters.toFix(parseFloat(  p.int ))
                                p.int_left= filters.toFix(parseFloat(  p.int_left ))
                                p.int_sum= filters.toFix(parseFloat(  p.int_sum ))

                                if( (p.param && p.param.type=='LPR') || p.result.total_lpr   ){
                                    len=p.result.total_lpr.length
                                    lpr=p.result.total_lpr

                                    // 合并利率部分
                                    let algorithm=''
                                    let newObj={}
                                    let total_lpr_merge=[]

                                    // let lpr_mode=p.param.lpr_mode
                                    let lpr_mode=data.part1[0].param.lpr_mode  //new
                                    let int_mode='int1'
                                    if(lpr_mode=='lpr1'){
                                    lpr_mode='lpr_1'
                                    }else{
                                    lpr_mode='lpr_5'
                                    int_mode='int5'
                                    }
                                    // 合并利率部分



                                    for(let i=0;i<len;i++){
                                        if(i!=len-1){
                                            a1=a1+"("+lpr[i].lpr_1+'%/'+that.method_year+")*"+lpr[i].days+"*"+ p.capital+'+'
                                            a5=a5+"("+lpr[i].lpr_5+'%/'+that.method_year+")*"+lpr[i].days+"*"+  p.capital+'+'
                                        }else{
                                            a1=a1+"("+lpr[i].lpr_1+'%/'+that.method_year+")*"+lpr[i].days+"*"+  p.capital
                                            a5=a5+"("+lpr[i].lpr_5+'%/'+that.method_year+")*"+lpr[i].days+"*"+  p.capital
                                    }
                                    
                                    }
                                    p.result.algorithm_1=a1
                                    p.result.algorithm_5=a5

                                    // console.log('part1 algorithm_1:',a1)


                                    //算法中合并利率的逻辑
                                    for(let i=0;i<len;i++){   
                                        if(i==0){
                                            newObj= JSON.parse(JSON.stringify(lpr[i])) 
                                            newObj.int=Number(lpr[i][int_mode])
                                            // continue
                                            if(len==1){   //new
                                                newObj.algorithm =  p.ini_capital+' x ('+ newObj[lpr_mode]+'%' +'÷'+ data.part1[0].param.year+')'+ ' x '+newObj['days']
                                                total_lpr_merge.push(newObj)
                                            }
                                        }else if(i>0  ){  // && i<len-1   && i<len-1 
                                            if( lpr[i][lpr_mode]== lpr[i-1][lpr_mode]  ){
                                                newObj['endDate']=lpr[i]['endDate']
                                                newObj['days']=lpr[i]['days']+ newObj['days']  //lpr[i-1]['days']
                                                newObj.int=newObj.int+Number(lpr[i][int_mode])
                                            if(i==len-1){
                                                // console.log('lpr_mode1:',lpr_mode)
                                                // newObj.algorithm =  p.ini_capital+' x ('+ newObj[lpr_mode]+'%' +'÷'+ p.param.year+')'+ ' x '+newObj['days']
                                                newObj.algorithm =  p.ini_capital+' x ('+ newObj[lpr_mode]+'%' +'÷'+ data.part1[0].param.year+')'+ ' x '+newObj['days']   
                                                newObj.lpr_mode=lpr_mode
                                                newObj.int=newObj.int.toFixed(2)
                                                total_lpr_merge.push(newObj)
                                            }
                                
                                            }else{
                                                // console.log('lpr_mode2:',lpr_mode)
                                                // newObj.algorithm=  p.ini_capital+' x ('+ newObj[lpr_mode]+'%' +'÷'+ p.param.year+')'+ ' x '+newObj['days']
                                                newObj.algorithm=  p.ini_capital+' x ('+ newObj[lpr_mode]+'%' +'÷'+ data.part1[0].param.year+')'+ ' x '+newObj['days']  
                                                newObj.lpr_mode=lpr_mode
                                                newObj.int=newObj.int.toFixed(2)
                                                total_lpr_merge.push(newObj)
                                                // newObj=lpr[i]
                                                newObj= JSON.parse(JSON.stringify(lpr[i])) 
                                                newObj.int=Number(lpr[i][int_mode])
                                                newObj.algorithm= ''
                                
                                            }
                                
                                
                                        }
                                    
                                    
                                
                                    
                                    }

                                    p.result.total_lpr_merge=total_lpr_merge 
                                    for(let q of total_lpr_merge){
                                    if(!algorithm){
                                        algorithm=algorithm+q.algorithm
                                    }else{
                                        algorithm=algorithm+'+'+q.algorithm
                                    }
                                    
                                    }
                                    p.result.algorithm_merge=algorithm
                                    algorithm=''
                                    //算法中合并利率的逻辑

                                }
                            }

                            a1=''
                            a5=''

                            if(data.part2 && data.part2.length>0){
                                for(let p of data.part2){
                                    p.int= filters.toFix(parseFloat(  p.int ))
                                    p.int_left= filters.toFix(parseFloat(  p.int_left ))
                                    p.int_sum= filters.toFix(parseFloat(  p.int_sum ))


                                    if( (p.param && p.param.type=='LPR') || p.result.total_lpr  ){
                                        len=p.result.total_lpr.length
                                        lpr=p.result.total_lpr

                                        // 合并利率部分
                                        let algorithm=''
                                        let newObj={}
                                        let total_lpr_merge=[]

                                        // let lpr_mode=p.param.lpr_mode
                                        let lpr_mode=data.part2[0].param.lpr_mode  //new
                                        let int_mode='int1'
                                        if(lpr_mode=='lpr1'){
                                            lpr_mode='lpr_1'
                                        }else{
                                            lpr_mode='lpr_5'
                                            int_mode='int5'
                                        }
                                        // 合并利率部分

                                        for(let i=0;i<len;i++){
                                            if(i!=len-1){
                                            a1=a1+"("+lpr[i].lpr_1+'%/'+that.method_year+")*"+lpr[i].days+"*"+ p.capital+'+'
                                            a5=a5+"("+lpr[i].lpr_5+'%/'+that.method_year+")*"+lpr[i].days+"*"+  p.capital+'+'
                                            }else{
                                            a1=a1+"("+lpr[i].lpr_1+'%/'+that.method_year+")*"+lpr[i].days+"*"+  p.capital
                                            a5=a5+"("+lpr[i].lpr_5+'%/'+that.method_year+")*"+lpr[i].days+"*"+  p.capital
                                            }
                                            
                                        }
                                        p.result.algorithm_1=a1
                                        p.result.algorithm_5=a5
                        
                                       // console.log('part2 algorithm_1:',a1)
                                        //算法中合并利率的逻辑
                                        for(let i=0;i<len;i++){   //算法中合并利率的逻辑
                                            if(i==0){
                                                newObj= JSON.parse(JSON.stringify(lpr[i])) 
                                                newObj.int=Number(lpr[i][int_mode])
                           
                                                if(len==1){   //new
                                                    newObj.algorithm =  p.ini_capital+' x ('+ newObj[lpr_mode]+'%' +'÷'+ data.part2[0].param.year+')'+ ' x '+newObj['days']
                                                    total_lpr_merge.push(newObj)
                                                }
                                               

                                                // continue
                                            }else if(i>0  ){  // && i<len-1   && i<len-1 
                                            if( lpr[i][lpr_mode]== lpr[i-1][lpr_mode]  ){
                                                newObj['endDate']=lpr[i]['endDate']
                                                newObj['days']=lpr[i]['days']+ newObj['days']  //lpr[i-1]['days']
                                                newObj.int=newObj.int+Number(lpr[i][int_mode])
                                                if(i==len-1){
                                                // console.log('lpr_mode1:',lpr_mode)
                                                newObj.algorithm =  p.ini_capital+' x ('+ newObj[lpr_mode]+'%' +'÷'+  p.param.year  +')'+ ' x '+newObj['days']
                                                newObj.lpr_mode=lpr_mode
                                                newObj.int=newObj.int.toFixed(2)
                                                total_lpr_merge.push(newObj)
                                                }
                                
                                            }else{
                                                // console.log('lpr_mode2:',lpr_mode)
                                                // newObj.algorithm=  p.ini_capital+' x ('+ newObj[lpr_mode]+'%' +'÷'+  p.param.year +')'+ ' x '+newObj['days']
                                                newObj.algorithm=  p.ini_capital+' x ('+ newObj[lpr_mode]+'%' +'÷'+  data.part2[0].param.year +')'+ ' x '+newObj['days']
                                                newObj.lpr_mode=lpr_mode
                                                newObj.int=newObj.int.toFixed(2)
                                                total_lpr_merge.push(newObj)
                                                // newObj=lpr[i]
                                                newObj= JSON.parse(JSON.stringify(lpr[i])) 
                                                newObj.int=Number(lpr[i][int_mode])
                                                newObj.algorithm= ''
                                
                                            }
                                
                                
                                            }
                                            
                                            
                                    
                                            
                                        }

                                        p.result.total_lpr_merge=total_lpr_merge 
                                        for(let q of total_lpr_merge){
                                            if(!algorithm){
                                            algorithm=algorithm+q.algorithm
                                            }else{
                                            algorithm=algorithm+'+'+q.algorithm
                                            }
                                            
                                        }
                                        p.result.algorithm_merge=algorithm
                                        algorithm=''
                                        //算法中合并利率的逻辑
                            
                    
                                    }
                                }

                            }

                            that.result=data 
                            // console.log('that.:',that.result)


                         
                        }else if(result.status=='fail'){
                            that.$message.error(result.failMsg);
                            sendParentMsg( result.failMsg , 'error')
                        }

            
        
                    }
                
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                
                });



            },

            bind_download(){ //mark
                // console.log('bind_download:'  )
                // let tableData=this.tableData
                var that=this

                if(!this.result.part1 || this.result.part1.length==0){
                    this.$message.error('需先计算得出有效结果');
                    sendParentMsg( '需先计算得出有效结果' , 'error')
                    return
                }


                let data=this.result 
                if (data.isPart1  &&  data.isPart1=='yes'  ){
                    data.params.duration1=data.params.endData
                }else{
                    data.params.duration1=data.params.expireDate
                }

                for(let item of data.part1){
                    if(!item.startDate && item.result){
                        item.startDate=item.result.startDate
                    } 
                    if(!item.endDate && item.result){
                        item.endDate=item.result.endDate
                    } 
                    if(!item.amount){
                        item.amount= 0 
                    } 

                    if( (item.param && item.param.type && item.param.type=='LPR' ) || item.result.total_lpr   ){

                        if(item.result.lpr_mode=='lpr1'){
                        item.algorithm= item.result.algorithm_1
                        }else{
                        item.algorithm= item.result.algorithm_5
                        }
                    



                    }else{
                        item.algorithm= item.result.algorithm
                    }
                    


                

                }

                
                for(let item of data.part2){

                    if(!item.startDate && item.result){
                        item.startDate=item.result.startDate
                    } 
                    if(!item.endDate && item.result){
                        item.endDate=item.result.endDate
                    } 
                    if(!item.amount){
                        item.amount= 0 
                    } 

                    if( (item.param && item.param.type && item.param.type=='LPR' ) || item.result.total_lpr   ){

                        if(item.result.lpr_mode=='lpr1'){
                          item.algorithm= item.result.algorithm_1
                        }else{
                          item.algorithm= item.result.algorithm_5
                        }
                    



                    }else{
                        item.algorithm= item.result.algorithm
                    }
                    


                }

                data.r1=data.part1[data.part1.length-1].int_sum
                data.r2=data.part1[data.part1.length-1].sum 


                let datas= { 
                    whattodo: "downLoad_int5_docx",
                    tableData:data ,
                
                }
    
                

                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let url= this.$root.rootUrl+'mini_app_vip2'
                this.axios.post(url,datas
                ).then(function (res) {
                    var result=res.data
                    // window.console.log(res)
                    if(result.status=='badgate'){
                        that.$message({
                            message: '请先登录哦',
                            type: 'warning'
                        });
                        sendParentMsg( '请先登录哦' , 'info')
                    }else if(result.status=='ok'){
                        that.DownLoad(result.link)
                    }else if(result.status=='fail'){
                        that.$message.error(result.failMsg);
                        sendParentMsg( result.failMsg , 'error')
                    }
                    loading.close();
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                    loading.close();
                });


            },

            DownLoad(url){
                    //    var that=this

                window.open(url, '_blank');
 
            },
                        
            reset: function (e) {
                let params={              //params 新的参数集成
            
                int_limit: '', //0.00666667, //年息24%下的日利率
                amount:'',
                startDate: '', //new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate(),
                param1:'no',
                cond:[],
                endDate: new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate() ,
                expireDate: new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate() ,
                contract_int:0,
                expire_int:0,
                method_year: '360',
            
                ratio_mode1:'day',
                ratio1:'',
                lpr_mode1:'lpr1',
                //合同期内 end

                //逾期 start
                ratio_mode2:'day',
                ratio2:'',
                lpr_mode2:'lpr1',
                //逾期 end

                isInt:false,
                isExpireInt:false, 
                maxmode:'no',

                method_year:'360',
                days_mode:'mode_d1',
                

                part1:{}, //合同期内
                part2:{}, //合同期外

                explain:[], //一些注释


                }   

                // this.setData({
                //     params:params
                // })
                this.params=params


            },

            CheckDemo(){
                let params={               
            
                    amount: "10000",
                    startDate: "2019-05-19",
                    startDate_tmsp:1558195200,
                    endDate: "2022-04-25",
                    endDate_tmsp:1650816000,
                    expireDate: "2021-04-16",
                    expireDate_tmsp: 1618502400 ,
                    suitDate: "2022-04-25",
                    suitDate_tmsp: 1650816000 ,
                    cond: [
                
                    {amount: "1000", date: "2020-01-20"},
                    {amount: "3000", date: "2020-04-16", }
                    ],

                    days_mode: "mode_d1",
                    expire_int: 0,
                    isExpireInt: true,
                    isInt: true,
                    lpr_mode1: "lpr1",
                    lpr_mode2: "lpr1",
                    maxmode: "no",
                    method_year: "360",
            
                    ratio1: "0.0005",
                    ratio2: "0.0005",
                    ratio_mode1: "day",
                    ratio_mode2: "day",
                    part1:{}, //合同期内
                    part2:{}, //合同期外
                        
                } 
                
                
                
                    // this.setData({
                    // // isDemo:1,
                    // params:params 
                

                    // })
                this.params=params

                this.testDate()



            },

            
            testDate(){  //不可注释，用于案例模板的
                let s_tmsp= Date.parse(this.params.startDate)/1000
                let p='after'
                if(s_tmsp<this.gap_tmsp){
                    p='before'
                }

                // this.setData({
                // 'params.gap_tmsp':p
                // // date1: e.detail.value
                // })
                this.params.gap_tmsp=p
 
                if(this.params.startDate_tmsp<this.time_19820  ){  //如果合同成立于19年8月20日之前，以起诉日LPR来计算保护上限
                    let suitDate=null
                    if(this.params.suitDate){
                        suitDate=this.params.suitDate
                    }else if(this.params.endDate){
                        suitDate=this.params.endDate
                    }
                    if(suitDate){
                        this.getIntLimit(suitDate)
                    }else{
                        // this.setData({
                        // 'params.int_limit':''
                        // })
                        this.params.int_limit=''
                    }


                }else if(this.params.startDate_tmsp>=this.time_19820 ){
                    this.getIntLimit()
                }


            },





















            NewFormSubmit(){
                let obj={"template_id":"1001" , "sheet_name":"客户登记表","block":this.block,"block_msg":this.block_msg }
                // console.log('1001 NewFormSubmit emit')
                // console.log("this.$refs[formName]:",this.$refs['form'])
                this.$emit('SubmitNewForm',obj); 
            },
            CancelForm(){
                window.close();

            },

 

      
      
            
         

            handleCheck(row){
                // console.log("row:",row)

                let routeData = this.$router.resolve({name:"form", params: {mode:'check' ,template_id: '1002' ,  id: row._id} });
                window.open(routeData.href, '_blank'); 

            },

            bindDateChange1(value){

                // console.log("value:",value)

                let s=value
                let s_tmsp= Date.parse(s)/1000
                let p='after'
                if(s_tmsp<this.gap_tmsp){
                    p='before'
                }

                // this.setData({
                //     'params.startDate': s, //.replace(/-/g, '/') //e.detail.value
                //     'params.startDate_tmsp': s_tmsp,
                //     'params.gap_tmsp':p
          
                // })
                this.params.startDate_tmsp=s_tmsp
                this.params.gap_tmsp=p


                if(this.params.startDate_tmsp<this.time_19820  ){  //如果合同成立于19年8月20日之前，以起诉日LPR来计算保护上限
                    let suitDate=null
                    if(this.params.suitDate){
                        suitDate=this.params.suitDate
                    }else if(this.params.endDate){
                        suitDate=this.params.endDate
                    }
                    if(suitDate){
                        this.getIntLimit(suitDate)
                    }else{
                        // this.setData({
                        // 'params.int_limit':''
                        // })
                        this.params.int_limit=''
                    }


                }else if(this.params.startDate_tmsp>=this.time_19820 ){
                    this.getIntLimit()
                }


            },

            bindChangeEndDate(){
                if(this.params.startDate_tmsp && this.params.startDate_tmsp<this.time_19820  ){ 
                    let suitDate=null
                    if( !this.params.suitDate  && this.params.endDate){  // 没有设置起诉日期，但是设置了计算终止日期
                        suitDate=this.params.endDate
                        // this.setData({
                        // 'params.suitDate':this.data.params.endDate,
                        // 'params.suitDate_tmsp':this.data.params.endDate_tmsp,
                        // })
                        this.params.suitDate=this.params.endDate
                    }
                    if(suitDate){
                        this.getIntLimit(suitDate)
                    }


                }

            },


            beVip(){
                window.open('https://www.lawtip.cn/bevip')
            },


            getIntLimit(startDate=''){
                var that=this 
 
                var params= JSON.parse(JSON.stringify(this.params));
                params.amount=0

                if(startDate){
                    params.startDate=startDate
                }

                params.endDate= timestampToTime (Date.parse(params.startDate)/1000  + 86400*30 )
                // console.log('params.endDate:',params.endDate)
                params.isMuti='no'
                params.lpr_mode='lpr1'
                params.max_mode='max1'
                params.method='maxLPR'
                params.cond=[{  amount:0 ,date:  params.endDate  }]
                // cond= [{  amount:0 ,date: s2  }]
                params.days=1
                this.lpr_cal(params)





            },

            lpr_cal(params,mode='get_lpr_limit'){
                var that=this 
              

                var data= { 
                    // token: app.globalData.token,
                    startDate: params.startDate.replace(/\//g, "-")  , // s1.replace(/\//g, "-"),  //.replace(/-/g,""),
                    endDate: params.endDate.replace(/\//g, "-"), // s2.replace(/\//g, "-"),   //.replace(/-/g, ""),
                    whattodo:'LPRcal',
                    type: params.method,// that.data.method=='maxLPR'?  (that.data.max_mode=='max2'? 'lastLPR':'firstLPR' )  :that.data.method  ,  //that.data.method, //
                    amount: parseFloat(filters.toFix(parseFloat(params.amount))),
                    year: params.method_year,
                    // days:gap,
                    days_mode:params.days_mode,
                    lpr_mode:params.lpr_mode,
                    cond:params.cond,
                    isMuti:params.isMuti,
                    max_mode:params.max_mode 
                }
                // that.isallset=false
                 
                this.axios.post(this.$root.rootUrl+'cal2',data  //'https://11law.lawtip.cn/php/LPRcal5.php'
                ).then(function (res) {
                    window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        // console.log('result:',result)
                        if(result.status=='ok'){
                            // console.log(result.data)


                            // that.setData({
                            //     resArr:result.data 
                            // })
                            that.resArr=result.data 
                            if(mode=='get_lpr_limit'){
                                let total_lpr=result.data[0].result.total_lpr

                                if(total_lpr.length==0){
                          

                                    that.$message({
                                        type: 'info',
                                        message:'无选择日期的lpr利率可选，无法得出当前日期的最高利率',
                                        showClose: true,
                                        duration:3000,
                                    });
                                    sendParentMsg(  '无选择日期的lpr利率可选，无法得出当前日期的最高利率' , 'info')

                                    return
                                }
                                // let int_limit= total_lpr[0].lpr_1/100
                                let int_limit= total_lpr[total_lpr.length-1].lpr_1/100
                                // console.log("int_limit 0:",int_limit)
                      
                                int_limit= parseFloat(filters.toFix2( int_limit) )
                                int_limit=int_limit*4
                                // console.log("int_limit1:",int_limit)
                                // that.setData({
                                //     'params.int_limit':int_limit
                                // })
                                that.params.int_limit=int_limit

                    
                            }
                           
                               
                         
 
                        }else if(result.status=='fail'){
                            that.$message.error(result.failMsg);
                            sendParentMsg(  result.failMsg , 'error')
                        }
                        else if(result.status=='badgate'){
                            that.$message({
                                type: 'info',
                                message:'请先登录',
                                showClose: true,
                                duration:3000,
                            });
                            sendParentMsg(  '请先登录' , 'info')

                        }

            
        
                    }else{
                        that.$message({
                            type: 'info',
                            message:'服务器错误，请联系客服',
                            showClose: true,
                            duration:3000,
                        });
                        sendParentMsg(  '服务器错误，请联系客服' , 'error')

                    }
                
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                
                });













                

            },

            
          


             

        }
	}
    
    


    var filters = {
        toFix: function (value) {
            return value.toFixed(2)//此处2为保留两位小数
        },
        toFix2: function (value) {
            return value.toFixed(4)//此处2为保留两位小数
        }
    }

    function timestampToTime(timestamp) {
        var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = date.getDate() + '';
        // var h = date.getHours() + ':';   //
        // var m = date.getMinutes() + ':';//
        // var s = date.getSeconds();//
        if (M.length==1){
            M='0' +M
        }
        if (D.length==1){
            D='0' +D
        }
        return Y + M + D ;  //+ h + m + s
    }




</script>

<style scoped >
/* .el-menu{
    color:black;
} */

 

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.login_box{
	height: 250px;
	width:320px;
	/* border:1px solid rgb(191, 192, 185); */
	position: fixed;
	bottom: 15%;
	right: 10%;
	z-index: 999;

	display: flex;
	flex-direction: column;
	/* justify-content: flex-start; */
	align-items: center;
	background-color: rgba(82, 81, 81, 0.3);

	/* justify-content: space-between; */
	 
}
.login_box img{
	width:35px;
	height: 29px;
	margin:auto;
}

.login_box .row{
	display: flex;
	flex-direction: row;
	width: 100%;
}

.table{
	width:100%;
	height: 100%;
	/* background-image: url();
 	background-image: url('https://www.lawtip.cn/images/bg.jfif');
	background-repeat:no-repeat;
	background-size:cover;
	opacity: 0.7; */
	display: flex;
	flex-direction: row;
	margin-bottom:40px;
	/* color:black; */


	
}

.table .left{
	width:73%;
	/* border:1px solid rgb(188, 218, 18); */
	display: flex;
	flex-direction: column;
	align-items: center;

	/* overflow-y: scroll; */
	/* margin-bottom:20px; */
}

.table .right{
	width:22%;
	/* border:1px solid rgb(191, 192, 185); */

	padding-top:20px;
  

    display: flex;
	flex-direction: column;
    justify-content: flex-start;
	align-items: center;
     
}

.block-right{
    width:24%;
	/* border-left:1px solid rgb(191, 192, 185); */

	padding-top:20px;
  

    display: flex;
	flex-direction: column;
    justify-content: flex-start;
	align-items: center;
     
}

.bg{
	/* width:100%;
	height: 100%; */
	opacity: 0.7;
	/* object-fit: cover; */
	
	/* object-fit: contain; */
	max-width: 100%;
    height: auto;
}

.record_line{
    height: 40px;
    width:90%;
    background-color: rgba(221, 216, 216, 0.3);;
    line-height: 40px;
    padding-left: 15px;
}
 

/* .formtable{
	border:1px solid rgb(191, 192, 185);
} */




 

.buttonline{
	width:70%;
	display: flex;
	flex-direction: row;
}

.line{
	padding-right:10px;
	text-align: right;
}

.newtable{
	width:96%;
	margin-left:auto;
	margin-right:auto;
	/* border:1px solid rgb(156, 156, 154); */
	margin-top:15px;
	/* background-color: rgba(228, 225, 225, 0.5); */

    /* margin-bottom:20px; */
    
    padding-bottom: 80px;
}

.examine{
	/* border:1px solid rgb(156, 156, 154); */
	/* width:100%; */
	/* height: 200px; */
	max-width:100%;
	padding: 15px;
	display: flex;
	flex-direction: column;



}
.dec_box{
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	height: 60px;
	line-height: 60px;
	/* border:1px solid rgb(156, 156, 154); */

}



.tag_item{
    background-color: #eee7c0c4;
    height: 30px;
    line-height: 30px;
    margin-bottom: 10px;
    padding:0 0 0 10px;
    width:100%;
    display: flex;
    flex-direction: row;

    align-items: center;
    /* align-items: center; */
}

.tag_item2{
    /* background-color: #eee7c0c4; */
    height: 30px;
    line-height: 30px;
    margin-top: 30px;
    padding:0 0 0 10px;
    width:95%;
    display: flex;
    flex-direction: row;

    align-items: center;

    background-color: #d9ecff;
    color: #409eff;
    /* align-items: center; */
}

.line{
    text-align: right;
    padding-right:20px;
}
.affix_wrap{
    display:flex; 
    flex-direction:row;
    flex-wrap: wrap;
}

.affix_box{
    /* background-color: #fbfdff; */
    border: 1px solid #c0ccda;
    /* border: 1px solid #1557a1; */

    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 148px;
    /* height: 148px; */
    height: 178px;
    /* line-height: 146px; */
    /* vertical-align: top; */
    margin-left: 10px;

    cursor: pointer;
    display: flex;
    flex-direction: column;

}

.affix_box .up{
    height: 148px;
    width: 100;
}

.affix_box .down{
    height: 30px;
    width: 100%;
    /* border: 1px solid #c0ccda; */
    line-height: 30px;
    font-size:10px;
    overflow: hidden;
    text-align: center;
}

.affix_box img{
    width:100% ;
    max-height: 100%;
}

.interest_conflict_style_box{
    width: 50%;
    height: 100%;
    /* border: 1px solid #c0ccda; */
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}
.interest_conflict_style{
    /* float:right; */
    line-height:8px;
    margin-right:15px; 
    cursor: pointer;
    /* border: 1px solid #c0ccda; */
    font-size: 14px;
    margin-top: auto;
    margin-bottom: auto;
    z-index: 999;
    
}




.plus_box{
    /* margin-left: auto;
    margin-right: auto; */
  /* border: 1px dashed #666666; */
  /* width:70%; */
  width:100%;
  /* margin-top: 30px; */

 
  
  /* display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: left; */

}



.refund_box{
  /* border: 1rpx solid #da2121; */
  width:100%;
  text-align: left;
  font-size:15px;
  margin-bottom: 6px;
  height: 30px;
  line-height: 30px;
  display: flex;
  flex-direction: row;

}

.newline{
    width:100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    /* border: 1px solid #2187da; */
    height: 40px;
    line-height: 40px;
    padding-bottom:10px;
}

.newline .item_name{
    width:20%;
    text-align: center;
    padding-left: 40px;
    /* border: 1px solid #2187da; */
}

.newline .item_detail{
    width: 30%;
}

.tips{
  font-size:14px;
  /* float: right; */
  padding-left: 20px;
  /* text-decoration: underline; */
  color: rgb(19, 109, 145);
 
}
 

.result{
  display: flex;
  flex-direction: column;
  margin:0 30px;
  align-items: flex-start;
  font-size: 14px;  
  /* width:700rpx; */
  /* border: 1px solid rgb(53, 7, 7); */
  margin-left:auto;
  margin-right: auto;

  
}

.result_box{
  border: 1px dashed #dedede;

  display: flex;
  flex-direction: column;
  margin:15px;
  align-items: flex-start;
  font-size: 15px;
 
  width:95%;
  /* max-height: 600px;
  overflow-y: scroll; */

 
  
  /* margin: 20rpx 0 0 0;
  font-size: 25rpx;
  padding: 0 30rpx 0 10rpx; 
  font-weight: bold; */
  
}



.tips_box{
  border: 1px dashed #dedede;

  display: flex;
  flex-direction: column;
  margin:15px;
  align-items: flex-start;
  font-size: 15px;
 
  width:95%;
  max-height: 600px;
  overflow-y: scroll;

 
  
  /* margin: 20rpx 0 0 0;
  font-size: 25rpx;
  padding: 0 30rpx 0 10rpx; 
  font-weight: bold; */
  
}

 .tiptxt_error{
  margin: 2px 0 0 0;
  color: red;
}

.tiptxt{
  margin: 2px 0 0 0;
  /* color: red; */
}

.white-space {

  white-space:pre

}

.guide{
  /* font-size:22rpx; */
  float: right;
  /* padding-right: 20rpx; */
  text-decoration: underline;
  margin-right: 20px;
  color: rgb(19, 109, 145);
  cursor: pointer;
}


.item_result{
  margin: 20px 0 0 0;
  font-size: 14px;
  padding: 0 30px 0 10px; 
}

.item_result2{
  margin: 20px 0 0 0;
  font-size: 14px;
  padding: 0 30px 0 10px; 
  font-weight: bold;
}



.table2{
  display: flex;
  flex-direction: column;
  margin:15px;
  align-items: flex-start;
  font-size: 14px;
  border: 1px solid #dedede;  
  width:95%;
  max-height: 900px;
  overflow-y: scroll;

}

 

.table-name{
  width:240px

}

.table-detail{
  width:160px;
  text-align: center;
 
}

.table-detail2{
  width:210px;
  text-align: center;
 
}

.table-item{
  display:flex;
  flex-direction: row;
  margin:15px 0 10px 0;
  align-items: center;
 
}


</style>
